import { Routes } from '@angular/router';
import { DeploymentsAndInstancesComponent } from './components/deployments-and-instances/deployments-and-instances.component';
import { deploymentWorkflowResolver } from './resolver/deployment-workflow.resolver';

export const routes: Routes = [
	{
		path: '',
		data: {
			breadcrumb: 'DEPLOYMENTS_AND_INSTANCES.BREADCRUMBS.MAIN'
		},
		children: [
			{
				path: 'deploy-history/:id/workflow',
				data: {
					breadcrumb:
						'DEPLOYMENTS_AND_INSTANCES.BREADCRUMBS.DEPLOYMENT_TRACKING'
				},
				resolve: {
					deployment: deploymentWorkflowResolver
				},
				loadComponent: () =>
					import(
						'./components/deployment-workflow/deployment-workflow.component'
					).then((component) => component.DeploymentWorkflowComponent)
			},
			{
				path: '',
				component: DeploymentsAndInstancesComponent,
				children: [
					{ path: '', redirectTo: 'app-instances', pathMatch: 'full' },
					{
						path: 'history',
						pathMatch: 'full',
						loadComponent: () =>
							import(
								'./components/deployment-history-list/deployment-history-list.component'
							).then((component) => component.DeploymentHistoryListComponent)
					},
					{
						path: 'versions',
						pathMatch: 'full',
						loadComponent: () =>
							import(
								'./components/deployment-version/deployment-version.component'
							).then((component) => component.DeploymentVersionComponent)
					},
					{
						path: 'app-instances',
						loadComponent: () =>
							import(
								'./components/app-instance-list/app-instance-list.component'
							).then((component) => component.AppInstanceListComponent)
					}
				]
			}
		]
	}
];
